package com.milta.core.mode

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class AppModeManager(private val storage: AppModeStorage) {

    private val _mode = MutableStateFlow(restoreMode())
    val mode: StateFlow<AppMode> = _mode

    fun setMode(mode: AppMode) {
        _mode.value = mode
        storage.saveMode(mode.name)
    }

    /**
     * Initializes the mode right after login/registration from the JWT `role` claim
     * ("Driver" or "Enterprise" — Enterprise takes priority for dual-role accounts,
     * see [com.milta.core.auth.JwtParser.extractRole]).
     */
    fun setModeFromRole(role: String) {
        setMode(if (role == "Driver") AppMode.DRIVER else AppMode.ENTERPRISE)
    }

    fun reset() {
        storage.clear()
        _mode.value = AppMode.ENTERPRISE
    }

    private fun restoreMode(): AppMode =
        storage.getMode()?.let { saved ->
            AppMode.entries.firstOrNull { it.name == saved }
        } ?: AppMode.ENTERPRISE
}
